import React, { lazy, Suspense, useEffect } from "react";
import Banner from "./components/banner/Banner";
import Navbar from "./components/navbar/Navbar";
import Projects from "./components/projects/Projects";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import BackToTop from "./components/BackToTop";
import axios from "axios";

const LazyResume = lazy(() => import("./components/resume/Resume"));
const LazyContact = lazy(() => import("./components/contact/Contact"));
const LazyFooterBottom = lazy(() => import("./components/footer/FooterBottom"));

function App() {

  useEffect(() => {

    // axios.get("http://localhost:2912/secret")
    //   .then(function (response) {
    //     // handle success
    //     console.log("Api call---", response.data);
    //   })
    // console.log("Api call---")
    const fetchSecret = async () => {
      try {
        const response = await axios.get("http://localhost:2912/secret");
        console.log("Api call---", response.data);
      } catch (error) {
        console.error("API error:", error);
      }
    };

    fetchSecret();


  }, [])

  return (
    <div className="w-full h-auto bg-bodyColor text-lightText px-4">
      <Navbar />
      <BackToTop />
      <div className="max-w-screen-xl mx-auto">
        <Banner />
        <Projects />
        <Suspense fallback={null}>
          <LazyResume />
        </Suspense>
        {/*<TmpContact />*/}
        <Suspense fallback={null}>
          <LazyContact />
        </Suspense>
        <Suspense fallback={null}>
          <LazyFooterBottom />
        </Suspense>
      </div>
      <Analytics />
      <SpeedInsights />
    </div>
  );
}

export default App;
